module.exports = __webpack_public_path__ + "assets/images/makedonia_tv.349a759e632b02c59959b187463b98c7.png";